import React from "react";

export default function useFileDownload(getName: () => string) {
    return function (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        const target = evt.target as HTMLAnchorElement;
        if (target.tagName !== "A") return;
        const linkAddr = target.href;

        if (linkAddr.lastIndexOf(".") === -1) return; // 没有扩展名的不管
        if (linkAddr.lastIndexOf("?") !== -1) return; // 地址中包含查询字符串说明可能不是附件

        evt.preventDefault();
        const downloadUrl = `${target.href}?name=${encodeURIComponent(
            getName()
        )}`;
        window.open(downloadUrl);
    };
}
